
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatSnackBarConfig, MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { HttpClientModule } from '@angular/common/http';
import { PortalModule } from '@angular/cdk/portal';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import { ClipboardModule } from '@angular/cdk/clipboard';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter,MatMomentDateModule} from '@angular/material-moment-adapter';


import { VendorsComponent } from './vendors.component';
import { MatButtonModule } from '@angular/material/button'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatTreeModule, } from '@angular/material/tree'
import { MatBadgeModule } from '@angular/material/badge'
import { MatCheckboxDefaultOptions, MatCheckboxModule, MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatTooltipDefaultOptions, MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip'
import { MatSliderModule } from '@angular/material/slider'
import { MatIconModule } from '@angular/material/icon'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatListModule } from '@angular/material/list'
import { MatSelectModule } from '@angular/material/select'
import { MatRadioModule } from '@angular/material/radio'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'

import { MatFormFieldAppearance, MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatDatepickerModule } from '@angular/material/datepicker'


import { MatCardModule } from '@angular/material/card'
import { DateAdapter, MatNativeDateModule, MatRippleModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS, RippleConfig } from '@angular/material/core'
import { MatChipsModule } from '@angular/material/chips'
import { MatTabsModule } from '@angular/material/tabs'
import { MatDialogModule } from '@angular/material/dialog'
import { MatButtonToggleModule } from '@angular/material/button-toggle'


import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatGridListModule } from '@angular/material/grid-list'
import { MatTableModule } from '@angular/material/table'
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorDefaultOptions, MatPaginatorModule, MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator'
import { MatMenuModule } from '@angular/material/menu'
import { MatDividerModule } from '@angular/material/divider'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { registerLocaleData } from '@angular/common';
import localeCa from '@angular/common/locales/ca';

registerLocaleData(localeCa)

const paginatorOptions: MatPaginatorDefaultOptions = {
  formFieldAppearance: 'outline'
}

const toolTipOptions: MatTooltipDefaultOptions = {
  showDelay: 400,
  hideDelay: 200,
  touchendHideDelay: 2000,
  position: 'right'
}

const snackBarOptions: MatSnackBarConfig = {
  verticalPosition: 'bottom',
  horizontalPosition: 'right',
  duration: 6000,
  panelClass: 'snack-panel',
}

// const rippleConfig:RippleConfig={
//   color:"red",
//   radius:500
// }



@NgModule({
  declarations: [
    VendorsComponent
  ],
  imports: [ReactiveFormsModule, FormsModule, MatButtonModule, MatToolbarModule, MatIconModule, MatSidenavModule, MatListModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatGridListModule, MatTableModule, MatSortModule, MatPaginatorModule, MatMenuModule, MatDividerModule, OverlayModule, MatCheckboxModule, MatRippleModule, MatChipsModule, MatTabsModule, MatButtonToggleModule, HttpClientModule, MatDialogModule, CdkAccordionModule, MatDatepickerModule, MatSelectModule, DragDropModule, MatProgressSpinnerModule, MatExpansionModule, PortalModule, MatSnackBarModule, MatTreeModule, MatRadioModule, MatSlideToggleModule, MatTooltipModule, MatSliderModule, MatBadgeModule, MatProgressBarModule, MatStepperModule, ClipboardModule,MatNativeDateModule,MatMomentDateModule],
  exports: [
    ReactiveFormsModule, FormsModule, VendorsComponent, MatButtonModule, MatToolbarModule, MatIconModule, MatSidenavModule, MatListModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatGridListModule, MatTableModule, MatSortModule, MatPaginatorModule, MatMenuModule, MatDividerModule, OverlayModule, MatCheckboxModule, MatCardModule, MatRippleModule, MatChipsModule, MatTabsModule, MatButtonToggleModule, HttpClientModule, MatDialogModule, CdkAccordionModule, MatDatepickerModule, MatSelectModule, DragDropModule, MatProgressSpinnerModule, MatExpansionModule, PortalModule, MatSnackBarModule, MatTreeModule, MatRadioModule, MatSlideToggleModule, MatTooltipModule, MatSliderModule, MatBadgeModule, MatProgressBarModule, MatStepperModule, ClipboardModule
  ], providers: [
    { provide: LOCALE_ID, useValue: "ca" },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: toolTipOptions
    }, {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: snackBarOptions
    },
    { provide: MAT_DATE_LOCALE, useValue: 'ca' },
    { provide: DateAdapter, useClass: MomentDateAdapter},
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          //dateInput: ['L', 'lll'],
          //dateInput:['lll']
          dateInput:'DD/MM/YYYY',
        },
        display: {
          //dateInput: 'lll',
          dateInput:'DD/MM/YYYY',  
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      }
    }
    // ,{
    //   provide: MAT_RIPPLE_GLOBAL_OPTIONS,
    //   useValue: rippleConfig
    // }
    
    , {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: paginatorOptions
    },
    //{provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'check' } as MatCheckboxDefaultOptions}

  ]
})
export class VendorModule { }
